module.exports = __webpack_public_path__ + "img/style_6_pl.fd967777.jpeg";